{
    "name": "@rio-cloud/rio-uikit",
    "version": "3.0.1",
    "description": "The RIO UIKIT component library",
    "repository": {
        "type": "git",
        "url": "https://bitbucket.collaboration-man.com/projects/RIOFRONT/repos/uikit-web/browse"
    },
    "scripts": {
        "build": "npm run build:icons && npm run build:styles && npm run build:lib && npm run format-code && echo '\n📦 Publish to npm only from within 'package' folder 📦'",
        "build:lib": "vite build",
        "build:styles": "vite build --mode styles",
        "build:pageloader": "npm run build:pageloader:rio && npm run build:pageloader:man && npm run build:pageloader:scania && npm run build:pageloader:traton && npm run build:pageloader:vw",
        "build:pageloader:rio": "vite build --mode pageloader-rio",
        "build:pageloader:man": "vite build --mode pageloader-man",
        "build:pageloader:scania": "vite build --mode pageloader-scania",
        "build:pageloader:traton": "vite build --mode pageloader-traton",
        "build:pageloader:vw": "vite build --mode pageloader-vw",
        "build:mcp": "npm run build:styles && npm --prefix uikit-mcp run build:server && npm --prefix uikit-mcp run build:index",
        "build:versionList": "node tools/buildVersionList.ts",
        "new-version:patch": "node tools/newVersion.ts patch",
        "new-version:minor": "node tools/newVersion.ts minor",
        "new-version:major": "node tools/newVersion.ts major",
        "new-version:beta": "node tools/newVersion.ts beta",
        "build:figma-plugin": "vite build --mode figma-plugin",
        "build:vscode-annotate-extension": "cd uikit-vscode-annotate-extension && npm run compile && extension_version=$(node -p \"require('./package.json').version\") && export_file=\"export/v$extension_version/uikit-annotate-$extension_version.vsix\" && mkdir -p \"export/v$extension_version\" && npx --yes @vscode/vsce package --allow-missing-repository --out \"$export_file\" && test -f \"$export_file\"",
        "validate:icon-metadata": "node tools/validateIconMetadata.mjs",
        "validate:mcp": "npm --prefix uikit-mcp run validate:index",
        "build:icons": "svgo -f uikit-icons/svgs && vite build --mode icons",
        "format-code": "npm run format-code:uikit && npm run format-code:demo",
        "format-code:uikit": "biome format --write .",
        "format-code:demo": "biome format --write uikit-demo/src",
        "lint": "biome check --max-diagnostics 2000",
        "lint-fix": "biome check --write",
        "test": "vitest run",
        "test:ci": "vitest run --reporter=junit --outputFile.junit=./results/jest/react18.xml",
        "test:react19": "node tools/testReact19.mjs",
        "test:ci:react19": "node tools/testReact19.mjs --reporter=junit --outputFile.junit=./results/jest/react19.xml",
        "test:all-react": "npm test && npm run test:react19",
        "test-dev": "vitest",
        "typecheck": "tsc --noEmit",
        "typecheck:react19": "node tools/typecheckReact19.mjs",
        "typecheck:all": "npm run typecheck && npm run typecheck:react19",
        "test:ui": "node tools/testUI.js && backstop reference --config='test/backstop/config.js' && backstop test --config='test/backstop/config.js'",
        "coverage": "vitest run --coverage",
        "license-check": "echo license-check",
        "check-licenses": "echo check-licenses"
    },
    "author": "TB Digital Services GmbH",
    "license": "Apache-2.0",
    "type": "module",
    "files": [
        "**/*.*"
    ],
    "exports": {
        "./*": {
            "types": "./*.d.ts",
            "default": "./*.js"
        },
        "./package.json": "./package.json",
        "./version.json": "./version.json"
    },
    "typesVersions": {
        "*": {
            "*": [
                "*"
            ]
        }
    },
    "devDependencies": {
        "@biomejs/biome": "2.5.7",
        "@rio-cloud/biome-config": "2.0.0",
        "@rio-cloud/vite-plugin-frontend-license-check": "3.1.1",
        "@testing-library/dom": "10.4.1",
        "@testing-library/jest-dom": "7.0.0",
        "@testing-library/react": "16.3.2",
        "@testing-library/user-event": "14.6.3",
        "@types/heremaps": "3.1.14",
        "@types/node": "24.10.1",
        "@types/react": "18.3.18",
        "@types/react-dom": "18.3.5",
        "@types/react-redux": "7.1.34",
        "@types/resize-observer-browser": "0.1.11",
        "@vitejs/plugin-react": "6.0.5",
        "@vitest/coverage-v8": "4.1.10",
        "autoprefixer": "10.5.4",
        "backstopjs": "6.3.25",
        "dotenv": "17.4.2",
        "glob": "13.0.6",
        "happy-dom": "20.11.1",
        "jsdom": "30.0.1",
        "jsdom-global": "3.0.2",
        "postcss": "8.5.25",
        "postcss-preset-env": "11.3.2",
        "postcss-short": "5.0.0",
        "pre-commit": "2.0.0",
        "react": "18.3.1",
        "react-dom": "18.3.1",
        "react-dom-types-19": "npm:@types/react-dom@19.2.4",
        "react-intl": "10.1.20",
        "react-types-19": "npm:@types/react@19.2.18",
        "rollup-plugin-copy": "3.5.0",
        "sass": "1.102.0",
        "strip-ansi": "7.2.0",
        "svgo": "4.0.2",
        "typescript": "5.9.3",
        "vite": "8.2.0",
        "vite-plugin-dts": "5.0.3",
        "vite-plugin-zip-pack": "1.2.4",
        "vitest": "4.1.10",
        "vitest-fetch-mock": "0.4.5"
    },
    "peerDependencies": {
        "react": "^18.0.0 || ^19.0.0",
        "react-dom": "^18.0.0 || ^19.0.0"
    },
    "dependencies": {
        "@daypicker/react": "^10.0.1",
        "@dnd-kit/core": "^6.3.1",
        "@dnd-kit/modifiers": "^9.0.0",
        "@dnd-kit/sortable": "^10.0.0",
        "@dnd-kit/utilities": "^3.2.2",
        "@formkit/auto-animate": "^0.10.0",
        "@rio-cloud/iframe-resizer": "^1.1.1",
        "@rio-cloud/react-datetime": "^3.2.0",
        "@tanstack/react-virtual": "^3.14.9",
        "date-fns": "^4.4.0",
        "driver.js": "^1.8.0",
        "es-toolkit": "^1.50.0",
        "moment": "^2.30.1",
        "motion": "^12.43.0",
        "natural-orderby": "^5.0.0",
        "prop-types": "^15.8.1",
        "react-content-loader": "^7.1.2",
        "react-custom-scrollbars-4": "^4.5.1",
        "react-dropzone": "^20.0.0",
        "react-imask": "^7.6.1",
        "react-toastify": "^11.1.0",
        "recharts": "^3.10.1",
        "tiny-invariant": "^1.3.3",
        "tslib": "^2.8.1"
    },
    "pre-commit": [
        "format-code"
    ],
    "browserslist": [
        "> 0.5%",
        "Firefox ESR",
        "not dead"
    ]
}
